import { ConnectingShipLink } from "utils/LinkUtils";
import { IconButton, Popover } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowProgress } from "@fortawesome/pro-duotone-svg-icons";
import ConnectingVisitInfo from "view/connectingVisits/components/info/ConnectingVisitInfo";
import { usePermission } from "components/utils/Permission";
import { intl } from "LocaleWrapper";
import usePopover from "components/hooks/usePopover";
import {
	CargoAction,
	ConnectingShipBerthing,
	ConnectingShipPortVisit,
	Location,
	Relation,
	Ship,
} from "__generated__/graphql";
import { useRef } from "react";

type ConnectingShipBerthType = Pick<ConnectingShipBerthing, "id"> & { location?: Pick<Location, "id" | "description"> | null, window?: { from?: number | null; to?: number | null; } | null };
type ConnectingVisitType = Pick<ConnectingShipPortVisit, "from" | "until" | "lastUpdateFromAgentOn" > & {
	id?: number;
	ship?: Pick<Ship, "id" | "name" | "planningNotes"> | null;
	location?: Pick<Location, "id" | "description"> | null;
	connectingShipBerthings?: ConnectingShipBerthType[] | null;
	agent?: Pick<Relation, "id" | "name"> | null;
};

type ConnectingVisitFieldProps = {
	action?: Pick<CargoAction, "shipToShip" | "connectingVisitNotes"> & {
		id: number | null;
		connectingShipPortVisit?: ConnectingVisitType | null;
		connectingShipBerthing?: ConnectingShipBerthType | null;
	} | null;
	refetch?: () => void;
};
const ConnectingVisitField = ({ action, refetch }: ConnectingVisitFieldProps) => {
	const { isRTR } = usePermission();

	const { popoverProps, onPopoverOpen, onPopoverClose } = usePopover({
		trigger: "hover",
	});

	const closeTimer = useRef<ReturnType<typeof setTimeout>>();

	const handleMouseEnter = (event: React.SyntheticEvent) => {
		clearTimeout(closeTimer.current);
		onPopoverOpen(event);
	};

	const handleMouseLeave = () => {
		closeTimer.current = setTimeout(() => {
			onPopoverClose();
		}, 150);
	};

	if (!action?.shipToShip) {
		return <></>;
	}

	const ship = action.connectingShipPortVisit?.ship;

	return <>

		<span style={{ whiteSpace: "nowrap", flexShrink: 0, marginRight: 8 }}>
			{isRTR && ship ? <ConnectingShipLink ship={ship} />
				: ship ? (
					<span>{ship.name}</span>
				) : action.shipToShip ? (
					<span>{intl.formatMessage({ id: "UNKNOWN_SHIP" })}</span>
				) : <></>}
		</span>

		{action?.connectingShipPortVisit && (
			<>
				<IconButton
					size="small"
					style={{ padding: 0, flexShrink: 0, overflow: "visible", borderRadius: 0 }}
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
				>
					<FontAwesomeIcon icon={faArrowProgress} style={{ color: "green", height: 13, width: 13 }} />
				</IconButton>

				<Popover
					{...popoverProps}
					slotProps={{
						paper: {
							style: { pointerEvents: "auto" },
							onMouseEnter: () => clearTimeout(closeTimer.current),
							onMouseLeave: handleMouseLeave,
						},
					}}>
					<div style={{ padding: 16 }}>
						<ConnectingVisitInfo
							onDelete={refetch ? () => refetch() : undefined}
							connectingVisit={{ ...action.connectingShipPortVisit, id: action.connectingShipPortVisit.id! }}
							action={action}
						/>
					</div>
				</Popover>
			</>
		)}
	</>;
};

export default ConnectingVisitField;
